// Migration service to help transition from localStorage to API-based database
import { migrateLocalStorage } from "../api/api";

// Function to migrate data from localStorage to the server-side database
export const migrateData = async (): Promise<boolean> => {
  try {
    // Attempt to migrate data
    await migrateLocalStorage();

    // If successful, mark migration as complete
    localStorage.setItem("finance_migration_complete", "true");
    localStorage.removeItem("finance_expenses");
    localStorage.removeItem("finance_income");
    localStorage.removeItem("finance_debts");
    console.log("[migration] Cleared legacy finance_* localStorage keys");

    return true;
  } catch (error) {
    console.error("Failed to migrate data:", error);
    return false;
  }
};

// Check if migration has been completed
export const isMigrationComplete = (): boolean => {
  return localStorage.getItem("finance_migration_complete") === "true";
};

// Set a flag to indicate which data source to use (localStorage or API)
export const setUseApiFlag = (useApi: boolean): void => {
  localStorage.setItem("finance_use_api", useApi ? "true" : "false");
};

// Check if we should use API or localStorage
export const shouldUseApi = (): boolean => {
  return localStorage.getItem("finance_use_api") === "true";
};
